import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredSlugs = [
  'qiezi-video-legal-risks',
  'teenager-protection-guide',
  'legal-video-platforms-guide',
  'internet-content-law-2026',
  'privacy-data-protection',
  'healthy-digital-habits',
];

const articleImages: Record<string, string> = {
  'qiezi-video-legal-risks': 'https://readdy.ai/api/search-image?query=Chinese%20legal%20documents%20and%20gavel%20on%20dark%20wooden%20desk%20with%20dramatic%20lighting%20professional%20legal%20atmosphere%20warning%20tone%20Chinese%20law%20theme%20warm%20amber%20tones%20editorial%20photography%20style%20with%20soft%20shadows%20and%20clean%20composition&width=800&height=500&seq=article-1&orientation=landscape',
  'teenager-protection-guide': 'https://readdy.ai/api/search-image?query=Warm%20family%20scene%20with%20parent%20and%20teenager%20using%20tablet%20together%20in%20bright%20modern%20living%20room%20caring%20atmosphere%20digital%20safety%20education%20theme%20soft%20natural%20lighting%20editorial%20photography%20Chinese%20family%20context%20harmonious%20composition&width=800&height=500&seq=article-2&orientation=landscape',
  'legal-video-platforms-guide': 'https://readdy.ai/api/search-image?query=Modern%20clean%20smartphone%20displaying%20colorful%20app%20icons%20of%20popular%20Chinese%20video%20platforms%20on%20a%20bright%20white%20desk%20minimalist%20tech%20lifestyle%20scene%20warm%20natural%20lighting%20editorial%20product%20photography%20harmonious%20composition&width=800&height=500&seq=article-3&orientation=landscape',
  'internet-content-law-2026': 'https://readdy.ai/api/search-image?query=Professional%20legal%20environment%20with%20Chinese%20law%20books%20and%20documents%20on%20a%20clean%20desk%20natural%20light%20from%20window%20serious%20and%20trustworthy%20atmosphere%20warm%20neutral%20tones%20editorial%20photography%20style%20with%20soft%20focus&width=800&height=500&seq=article-4&orientation=landscape',
  'privacy-data-protection': 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20smartphone%20with%20glowing%20red%20warning%20icons%20and%20lock%20symbols%20floating%20around%20cybersecurity%20danger%20concept%20dramatic%20lighting%20with%20warm%20amber%20accents%20high%20contrast%20editorial%20photography&width=800&height=500&seq=article-5&orientation=landscape',
  'healthy-digital-habits': 'https://readdy.ai/api/search-image?query=Calm%20and%20focused%20person%20reading%20on%20tablet%20in%20a%20cozy%20modern%20reading%20nook%20with%20plants%20and%20warm%20lighting%20healthy%20digital%20lifestyle%20concept%20soft%20natural%20tones%20editorial%20photography%20serene%20atmosphere&width=800&height=500&seq=article-6&orientation=landscape',
};

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => featuredSlugs.includes(a.slug));

  const categoryNameMap: Record<string, string> = {
    'risk-warning': '风险警示',
    'healthy-alternative': '健康替代',
    'legal-compliance': '法律合规',
    'youth-protection': '青少年保护',
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              阅读我们的深度分析文章，了解网络安全的重要知识。
            </p>
          </div>
          <Link
            to="/category/risk-warning"
            className="inline-flex items-center gap-1.5 text-accent-600 hover:text-accent-700 font-medium text-sm whitespace-nowrap transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.slug] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {categoryNameMap[article.category] || article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-foreground-500 text-xs">
                  <span>{article.author}</span>
                  <div className="flex items-center gap-3">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}